import { Button, Card, Grid, Icon, IconButton, Badge, Menu, MenuItem } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { setDarkMode, useMaterialUIController } from "context";
import colors from "assets/theme/base/colors";
import { useUser } from "context/UserContext";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { getEnums } from "utils/Enums";
import { get, postNoResponse } from "utils/WebService";
import routes from "routes";

export default function SystemWrapper({
    tabs,
    closeTab,
    handleSidenavMenus, onPageSelect }) {

    const [tabValue, setTabValue] = useState(tabs.length > 0 ? tabs[tabs.length - 1].key : "");

    const [controller, dispatch] = useMaterialUIController();
    const { primaryColor, darkMode } = controller;

    const { setUserPerfils,
        setUserName,
        setUserEmail,
        userFunctionalities,
        setUserFunctionalities,
        setUserAtivo,
        setUserId,
        setMotivoEncerramentoEnum,
        setProcessoPessoaTipo,
        setProcessoStatus,
        setProfileType,
        setRelacaoJuridico,
        setRoboEditalStatus,
        setRoboEditalWibsStatus,
        setStatusCasoProcessual,
        setTipoCasoEnum,
        setTipoComplementoJusticaEnum,
        setTipoIndiceEnum,
        setTipoJusticaEnum,
        setTipoPessoaEnum,
        setTipoPartesEnum,
        setFonteMovimentacaoEnum,
        setTipoMovimentacaoEnum,
        setStatusProcesso,
        setStatusPrazoEnum,
        setSistemasEnum,
        setUserGestor,
        setTipoEventoEnum,
        setTipoPerfilEnum,
        setTipoFiltroAgendaEnum,
        setTipoAgendaEnum,
        setTipoSistemaEnum,
        setTipoDocumentoProcessoEnum
    } = useUser();

    async function fetchEnums() {
        const enumsMap = await getEnums();

        if (enumsMap) {
            setMotivoEncerramentoEnum(enumsMap.motivoEncerramentoEnum || []);
            setProcessoPessoaTipo(enumsMap.processoPessoaTipo || []);
            setProcessoStatus(enumsMap.processoStatus || []);
            setProfileType(enumsMap.profileType || []);
            setRelacaoJuridico(enumsMap.relacaoJuridico || []);
            setRoboEditalStatus(enumsMap.roboEditalStatus || []);
            setRoboEditalWibsStatus(enumsMap.roboEditalWibsStatus || []);
            setStatusCasoProcessual(enumsMap.statusCasoProcessual || []);
            setSistemasEnum(enumsMap.sistemasEnum || []);
            setTipoCasoEnum(enumsMap.tipoCasoEnum || []);
            setTipoComplementoJusticaEnum(enumsMap.tipoComplementoJusticaEnum || []);
            setTipoIndiceEnum(enumsMap.tipoIndiceEnum || []);
            setTipoJusticaEnum(enumsMap.tipoJusticaEnum || []);
            setTipoPessoaEnum(enumsMap.tipoPessoaEnum || [])
            setTipoPartesEnum(enumsMap.tipoPartesEnum || [])
            setFonteMovimentacaoEnum(enumsMap.fonteMovimentacaoEnum || [])
            setTipoMovimentacaoEnum(enumsMap.tipoMovimentacaoEnum || [])
            setStatusProcesso(enumsMap.statusProcesso || [])
            setStatusPrazoEnum(enumsMap.statusPrazoEnum || [])
            setTipoEventoEnum(enumsMap.tipoEventoEnum || [])
            setTipoPerfilEnum(enumsMap.tipoPerfilEnum || [])
            setTipoFiltroAgendaEnum(enumsMap.tipoFiltroAgendaEnum || [])
            setTipoAgendaEnum(enumsMap.tipoAgendaEnum || [])
            setTipoSistemaEnum(enumsMap.tipoSistemaEnum || [])
            setTipoDocumentoProcessoEnum(enumsMap.tipoDocumentoProcessoEnum || [])
        }
    }

    useEffect(() => {
        get('/users/by-token')
            .then(({ id, funcionalidades }) => {
                if (id !== null) {
                    fetchEnums();
                    setUserId(id)
                    handleSidenavMenus(funcionalidades)
                    setUserFunctionalities(funcionalidades);
                    get('/users/by-id/'.concat(id))
                        .then(({ id, perfils, email, nome, ativo, temaDark, gestor }) => {
                            setUserPerfils(perfils);
                            setUserName(nome);
                            setUserEmail(email);
                            setUserAtivo(ativo);
                            setUserId(id);
                            setDarkMode(dispatch, temaDark);
                            setUserGestor(gestor)
                            sessionStorage.setItem('tema', temaDark);
                        });
                }

            }).catch(() => null);

    }, []);

    // Se as permissões mudarem em tempo de execução, atualizamos o menu sem precisar relogar!
    useEffect(() => {
        if (userFunctionalities && userFunctionalities.length > 0) {
            handleSidenavMenus(userFunctionalities);
        }
    }, [userFunctionalities]);

    function handleSetTabValue(newValue) {
        setTabValue(newValue);
    }

    const [anchorNotif, setAnchorNotif] = useState(null);
    const handleOpenNotif = (event) => setAnchorNotif(event.currentTarget);
    const handleCloseNotif = () => setAnchorNotif(null);

    const [notifResume, setNotifResume] = useState(null);

    const fetchNotifications = () => {
        get('/notifications/resume')
            .then((res) => {
                setNotifResume(res);
            }).catch(() => null);
    };

    useEffect(() => {
        // Fetch inicial
        fetchNotifications();

        // Polling para atualização periódica (a cada 30 segundos)
        const intervalId = setInterval(() => {
            fetchNotifications();
        }, 30000);

        return () => clearInterval(intervalId); // Limpa o intervalo se o componente desmontar
    }, []);

    const urgentCount = notifResume?.totalSolicitacoesUrgentes || 0;
    const todayCount = notifResume?.totalEventosHoje || 0;
    const delayedCount = notifResume?.totalEventosAtrasados || 0;
    const fichasHoje = notifResume?.totalFichasHoje || 0;
    const fichasAtrasadas = notifResume?.totalFichasAtrasadas || 0;
    const otherCount = (notifResume?.totalSolicitacoes || 0) + (notifResume?.totalEventos || 0) - urgentCount - todayCount - delayedCount;

    const hasUnread = urgentCount > 0 || todayCount > 0 || delayedCount > 0 || otherCount > 0 || fichasHoje > 0 || fichasAtrasadas > 0;

    let pulseDuration = "none";
    if (hasUnread) {
        if (urgentCount > 0 || delayedCount > 0 || fichasAtrasadas > 0) pulseDuration = "0.8s"; // Urgente/Atrasado = rápido
        else if (todayCount > 0 || fichasHoje > 0) pulseDuration = "1.5s"; // Hoje = moderado
        else pulseDuration = "3s"; // Demais = lento
    }

    useEffect(() => {
        // Ignora no ambiente de desenvolvimento para evitar travamentos com o hot-reload do webpack/yarn start
        if (process.env.NODE_ENV === "development" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
            return;
        }

        const handleBeforeUnload = (e) => {
            // Em formato ERP é mais seguro barrar qualquer tentativa de fechamento global
            // Assim engloba edições em andamento perfeitamente sem risco do usuário perder trabalho!
            e.preventDefault();
            e.returnValue = "Existem alterações não salvas ou tarefas pendentes. Deseja realmente sair?";
            return e.returnValue;
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, []);

    // Set custom page selector on window for external triggers (like Monitoria link)
    useEffect(() => {
        window.onPageSelectCustom = onPageSelect;
        return () => {
            window.onPageSelectCustom = null;
        };
    }, [onPageSelect]);

    // Periodical user activity heartbeat
    const sendActivityHeartbeat = () => {
        const token = sessionStorage.getItem('user');
        if (!token) return;

        const activeTabObj = tabs.find(t => t.key === tabValue);
        let actionName = activeTabObj ? activeTabObj.name : "Navegando no Sistema";
        
        let idDevedor = null;
        if (tabValue === "baseDeDados" || tabValue === "fila-trabalho") {
            idDevedor = sessionStorage.getItem('activeDevedorId') || null;
            if (idDevedor) {
                const devedorNome = sessionStorage.getItem('activeDevedorNome') || "Ficha";
                actionName = tabValue === "fila-trabalho" ? `Fila de Trabalho: ${devedorNome}` : `Acessando Ficha: ${devedorNome}`;
            } else {
                actionName = tabValue === "fila-trabalho" ? "Aguardando Fila de Trabalho" : "Visualizando Base de Dados";
            }
        }

        postNoResponse('/users/atividade', {
            ultimaAcao: actionName,
            idDevedor: idDevedor
        }).catch(() => null);
    };

    useEffect(() => {
        sendActivityHeartbeat();

        const intervalId = setInterval(() => {
            sendActivityHeartbeat();
        }, 45000); // 45s heartbeat

        const handleSessionUpdate = () => {
            sendActivityHeartbeat();
        };
        window.addEventListener('sessionStorageUpdate', handleSessionUpdate);

        return () => {
            clearInterval(intervalId);
            window.removeEventListener('sessionStorageUpdate', handleSessionUpdate);
        };
    }, [tabValue]);

    const renderNotifMenu = (
        <Menu
            anchorEl={anchorNotif}
            open={Boolean(anchorNotif)}
            onClose={handleCloseNotif}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            sx={{ mt: 1 }}
        >
            <MenuItem onClick={() => {
                handleCloseNotif();
                const flatRoutes = routes.flatMap(r => r.collapse ? r.collapse : r);
                const solRoute = flatRoutes.find(r => r.key === "solicitacoesSystem");
                if (solRoute) {
                    onPageSelect(solRoute);
                }
            }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <MDBox display="flex" alignItems="center" mb={0.5}>
                    <Icon fontSize="inherit" sx={{ mr: 1, color: urgentCount > 0 ? 'error.main' : 'warning.main', fontSize: '14px' }}>
                       assignment
                    </Icon>
                    <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                        Solicitações Pendentes
                    </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                   Você possui {notifResume?.totalSolicitacoes || 0} solicitações.{" "}
                   {urgentCount > 0 && <strong style={{ color: '#F44335' }}>({urgentCount} URGENTE)</strong>}
                </MDTypography>
            </MenuItem>

            {(notifResume?.hasProcessos !== false) && (
            <MenuItem onClick={() => {
                handleCloseNotif();
                const homeRoute = tabs.find(t => t.key === "home");
                if (homeRoute) {
                    onPageSelect(homeRoute);
                }
            }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <MDBox display="flex" alignItems="center" mb={0.5}>
                    <Icon fontSize="inherit" sx={{ mr: 1, color: (delayedCount > 0) ? 'error.main' : (todayCount > 0 ? 'warning.main' : 'info.main'), fontSize: '14px' }}>
                       event
                    </Icon>
                    <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                        Compromissos / Eventos
                    </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                   Total de {notifResume?.totalEventos || 0} eventos na pauta.{" "}
                   {todayCount > 0 && <strong style={{ color: '#FB8C00' }}>({todayCount} DO DIA) </strong>}
                   {delayedCount > 0 && <strong style={{ color: '#F44335' }}>({delayedCount} ATRASADO) </strong>}
                </MDTypography>
            </MenuItem>
            )}

            {(notifResume?.hasCobranca !== false) && (
            <MenuItem onClick={() => {
                handleCloseNotif();
                const homeRoute = tabs.find(t => t.key === "home");
                if (homeRoute) {
                    onPageSelect(homeRoute);
                }
            }} sx={{ p: 1.5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <MDBox display="flex" alignItems="center" mb={0.5}>
                    <Icon fontSize="inherit" sx={{ mr: 1, color: fichasAtrasadas > 0 ? 'error.main' : (fichasHoje > 0 ? 'warning.main' : 'info.main'), fontSize: '14px' }}>
                       contact_phone
                    </Icon>
                    <MDTypography variant="button" fontWeight="bold" sx={{ fontSize: '10px' }}>
                        Fichas Agendadas
                    </MDTypography>
                </MDBox>
                <MDTypography variant="caption" color="text" sx={{ fontSize: '10px', pl: 2.5 }}>
                   Você possui {fichasHoje || 0} fichas para hoje.{" "}
                   {fichasAtrasadas > 0 && <strong style={{ color: '#F44335' }}>({fichasAtrasadas} ATRASADAS) </strong>}
                </MDTypography>
            </MenuItem>
            )}
        </Menu>
    );

    function handleCloseTab(tab, tabIndex) {
        let tabKey = tab.key;
        let nextKey = tabs[tabIndex + 1]?.key;
        let previousKey = tabs[tabIndex - 1]?.key;
        if (tabKey === tabValue) {
            if (nextKey) handleSetTabValue(nextKey);
            else if (previousKey) handleSetTabValue(previousKey);
        }
        closeTab(tab);
    }

    useEffect(() => {
        if (tabs.length > 0) {
            const activeTab = tabs.find(tab => tab.active === true);
            if (activeTab) {
                setTabValue(activeTab.key);
            } else {
                setTabValue(tabs[tabs.length - 1].key);
            }
        } else {
            setTabValue("");
        }
    }, [tabs]);

    return (
        <DashboardLayout>
            <Grid container>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: "0.24rem", mb: -0.2 }}>
                    <MDBox display="flex" justifyContent="start" sx={{ overflowX: "auto", overflowY: "hidden", alignItems: "center", flex: 1 }}>
                        {tabs.map((tab, idx) => {
                            if (tab.component) {
                                const isSelected = tab.key === tabValue;
                                return (
                                    <Card
                                        key={tab.key + "-" + idx}
                                        sx={{
                                            marginRight: 0.25,
                                            minWidth: "auto",
                                            background: "transparent",
                                            borderRadius: 0,
                                            boxShadow: "none",
                                            borderBottom: isSelected ? `2px solid ${colors[primaryColor] ? colors[primaryColor].main : primaryColor}` : "2px solid transparent",
                                            transition: "all 0.2s ease-in-out",
                                            "&:hover": {
                                                background: "rgba(0,0,0,0.03)"
                                            }
                                        }}>
                                        <MDBox display="flex" alignItems="center" px={0.5}>
                                            <Button
                                                fullWidth
                                                sx={{
                                                    padding: "4px 8px",
                                                    minWidth: "auto",
                                                    minHeight: "28px",
                                                    textTransform: "none",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }}
                                                onClick={() => handleSetTabValue(tab.key)}>
                                                <MDTypography
                                                    variant="body2"
                                                    fontWeight={isSelected ? "medium" : "regular"}
                                                    color="text"
                                                    sx={{ whiteSpace: "nowrap", fontSize: 12 }}>
                                                    {tab.name}
                                                </MDTypography>
                                            </Button>
                                            {tabs.length > 1 && tab.key !== 'home' && (
                                                <IconButton
                                                    size="small"
                                                    sx={{
                                                        p: "2px",
                                                        width: "22px",
                                                        height: "22px",
                                                        ml: 0.5,
                                                    }}
                                                    onClick={() => handleCloseTab(tab, idx)}>
                                                    <MDTypography variant="body1" lineHeight={1}>
                                                        <Icon color="light" sx={{ fontSize: "16px !important" }}>close</Icon>
                                                    </MDTypography>
                                                </IconButton>
                                            )}
                                        </MDBox>
                                    </Card>
                                );
                            }
                            return null;
                        })}
                    </MDBox>

                    <MDBox display="flex" alignItems="center" mr={2}>
                        <IconButton
                            size="small"
                            disableRipple
                            color="inherit"
                            onClick={handleOpenNotif}
                            sx={{
                                p: 0,
                                "& .MuiBadge-badge": {
                                    height: 11,
                                    width: 11,
                                    borderRadius: "50%",
                                    border: "2px solid #fff",
                                    boxShadow: "0px 0px 4px rgba(0,0,0,0.3)",
                                    animation: hasUnread ? `pulse ${pulseDuration} infinite ease-in-out` : "none",
                                },
                                "@keyframes pulse": {
                                    "0%": {
                                        boxShadow: darkMode ? "0 0 0 0 rgba(255, 80, 80, 0.9)" : "0 0 0 0 rgba(244, 67, 54, 0.7)",
                                    },
                                    "70%": {
                                        boxShadow: darkMode ? "0 0 0 8px rgba(255, 80, 80, 0)" : "0 0 0 8px rgba(244, 67, 54, 0)",
                                    },
                                    "100%": {
                                        boxShadow: darkMode ? "0 0 0 0 rgba(255, 80, 80, 0)" : "0 0 0 0 rgba(244, 67, 54, 0)",
                                    },
                                },
                                "&:hover svg": {
                                    animation: "ring 1.5s ease-in-out",
                                },
                                "@keyframes ring": {
                                    "0%": { transform: "rotate(0deg)" },
                                    "15%": { transform: "rotate(15deg)" },
                                    "30%": { transform: "rotate(-10deg)" },
                                    "45%": { transform: "rotate(5deg)" },
                                    "60%": { transform: "rotate(-5deg)" },
                                    "75%": { transform: "rotate(0deg)" },
                                    "100%": { transform: "rotate(0deg)" }
                                }
                            }}
                        >
                            <Badge variant="dot" color="error" invisible={!hasUnread}>
                                <NotificationsIcon sx={{ color: "text.main", fontSize: "20px !important" }} />
                            </Badge>
                        </IconButton>
                        {renderNotifMenu}
                    </MDBox>
                </MDBox>
                <MDBox
                    width="100%"
                    height="auto">
                    {tabs.map((tab, idx) => {
                        if (tab.component)
                            return (
                                <div
                                    style={{ width: "100%", paddingLeft: 4 }}
                                    key={tab.key + "-" + idx}
                                    role="tabpanel"
                                    hidden={tabValue !== tab.key}
                                    id={`tabpanel-${tab.key}`}
                                    aria-labelledby={`tab-${tab.key}`}
                                >
                                    {React.cloneElement(tab.component, { onPageSelect })}
                                </div>
                            );
                        return null;
                    })}
                </MDBox>

            </Grid>
        </DashboardLayout>
    );
}

// Typechecking props for SystemWrapper
SystemWrapper.propTypes = {
    tabs: PropTypes.array.isRequired,
    closeTab: PropTypes.func.isRequired,
};
